import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ManagementComponent} from './management.component';
import {RouterModule} from '@angular/router';
import {ManagementRoutingModule} from './management.routing';
import {AdminLayoutComponent} from './layouts/admin-layout/admin-layout.component';
import {ComponentsModule} from './components/components.module';
import {TranslateModule} from '@ngx-translate/core';
import {ReactiveFormsModule} from '@angular/forms';



@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ManagementRoutingModule,
    ComponentsModule,
    TranslateModule,
    ReactiveFormsModule,

  ],
  declarations: [ManagementComponent, AdminLayoutComponent],
  providers: []
})
export class ManagementModule { }
